if ( typeof ProductVariants !== 'function' ) {

	class ProductVariants extends HTMLElement {

		constructor() {
			super();
			this.init();
		}

		init() {

			this._event = new Event('VARIANT_CHANGE');

			this.price = document.querySelector(`#product-price-${this.dataset.id}`);

			if ( this.price ) {
				this.priceOriginal = this.price.querySelector('[data-js-product-price-original]');
				this.priceCompare = this.price.querySelector('[data-js-product-price-compare]');
				this.priceUnit = this.price.querySelector('[data-js-product-price-unit]');
			}

				this.productForm = document.querySelector(`#product-form-${this.dataset.id}`);
				this.productFormWrapper = document.querySelector(`#add-to-cart-${this.dataset.id}`);
				if ( this.productForm ) {
					this.productQty = this.productForm.querySelector('[data-js-product-quantity]');
					this.addToCart = this.productForm.querySelector('[data-js-product-add-to-cart]');
					this.addToCartText = this.productForm.querySelector('[data-js-product-add-to-cart-text]');
				}

			this.addEventListener('change', this.onVariantChange);

				if ( this.hasAttribute('data-variant-required' ) ) {
						this.variantRequired = true;
						this.noVariantSelectedYet = true;
						if ( this.productFormWrapper ) {
							this.productFormWrapper.classList.add('variant-required-pending');
						}
				} else {
					this.variantRequired = false;
					this.noVariantSelectedYet = false;
				this.classList.add('variant-selected');
			}

			this.updateOptions();
			this.updateMasterId();
			this.updateUnavailableVariants();
			this.updateAvailabilityLabels();

			this.productStock = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity]`);
			this.productStockProgress = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-progress]`);
			if ( this.productStock && document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`) ) {
				this.productStockData = JSON.parse(document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`).dataset.inventory);
			}
			this.updateStock();

		}

		onVariantChange(){

			this.updateOptions();
			this.updateMasterId();
			this.updateVariantInput();
			if ( this.price ) {
				this.updatePrice();
			}
			this.updateStock();
			this.updateUnavailableVariants();
			this.updateAvailabilityLabels();
			this.updatePickupAvailability();
			if ( ! this.hasAttribute('data-no-history') ) {
				this.updateURL();
			}
			this.updateDetails();

				if ( this.productForm ) {
					if ( ! this.currentVariant || ! this.currentVariant.available ) {
						if ( this.variantRequired && this.noVariantSelectedYet ) {
							if ( this.productQty ) this.productQty.style.display = '';
							this.addToCart.classList.remove('disabled');
							this.addToCart.removeAttribute('aria-disabled');
							this.productForm.classList.remove('disabled-cart', 'unavailable-variant');
							this.addToCartText.textContent = this.hasAttribute('data-show-bundle-wording') ? KROWN.settings.locales.products_add_to_bundle_button : this.addToCartText.hasAttribute('data-show-preorder-wording') ? KROWN.settings.locales.products_preorder_button : KROWN.settings.locales.products_add_to_cart_button;
						} else {
							if ( this.productQty ) this.productQty.style.display = 'none';
							this.addToCart.classList.add('disabled');
							this.addToCart.setAttribute('aria-disabled', 'true');
							this.productForm.classList.add('disabled-cart');
							this.addToCartText.textContent = this.getSoldOutButtonText();
						}
					} else {
						if ( this.productQty ) this.productQty.style.display = '';
						this.addToCart.classList.remove('disabled');
						this.addToCart.removeAttribute('aria-disabled');
						this.productForm.classList.remove('disabled-cart');
					this.addToCartText.textContent = this.hasAttribute('data-show-bundle-wording') ? KROWN.settings.locales.products_add_to_bundle_button : this.addToCartText.hasAttribute('data-show-preorder-wording') ? KROWN.settings.locales.products_preorder_button : KROWN.settings.locales.products_add_to_cart_button;
					}
					if ( ! this.currentVariant ) {
						if ( this.variantRequired && this.noVariantSelectedYet ) {
							this.productForm.classList.remove('unavailable-variant');
						} else {
							this.productForm.classList.add('unavailable-variant');
							this.addToCartText.textContent = KROWN.settings.locales.products_unavailable_variant;
						}
					} else {
						this.productForm.classList.remove('unavailable-variant');
						this.clearVariantRequiredError();
					}
				}
				this.dispatchEvent(this._event);

		}

		updateOptions(){

			this.options = [];

			this.querySelectorAll('[data-js-product-variant-container]').forEach(elm=>{
				if ( elm.dataset.jsProductVariantContainer == 'radio' ) {
					elm.querySelectorAll('.product-variant__input').forEach(el=>{
						if ( el.checked ) {
							this.options.push(el.value);
						}
					});
				} else {
					if ( ! ( this.variantRequired && elm.selectedIndex == 0 ) ) {
						this.options.push(elm.value);
					}
				}
			});

				if ( this.variantRequired && this.noVariantSelectedYet && this.options.length >= parseInt(this.dataset.variants) ) {
					this.noVariantSelectedYet = false;
					this.classList.add('variant-selected');
						if ( this.productFormWrapper ) {
							this.productFormWrapper.classList.remove('variant-required-pending');
						}
					this.clearVariantRequiredError();
				}

		}

		updateMasterId(){
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options.map((option, index) => {
					return this.options[index] === option;
				}).includes(false);
			});
		}

		updatePrice(){
			
			if (!this.currentVariant) {
				if ( ! ( this.variantRequired && this.noVariantSelectedYet ) ) {
					this.priceOriginal.innerHTML = '';
					this.priceCompare.innerHTML = '';
					this.priceUnit.innerHTML = '';
				}
			} else {
				this.priceOriginal.innerHTML = this._formatMoney(this.currentVariant.price, KROWN.settings.shop_money_format);
				if ( this.currentVariant.compare_at_price > this.currentVariant.price ) {
					this.priceCompare.innerHTML = this._formatMoney(this.currentVariant.compare_at_price, KROWN.settings.shop_money_format);
				} else {
					this.priceCompare.innerHTML = '';
				}

				if ( this.currentVariant.unit_price_measurement ) {
					this.priceUnit.innerHTML = `
						${this._formatMoney(this.currentVariant.unit_price, KROWN.settings.shop_money_format)} / 
						${( this.currentVariant.unit_price_measurement.reference_value != 1 ? this.currentVariant.unit_price_measurement.reference_value + ' ' : '' )}
						${this.currentVariant.unit_price_measurement.reference_unit}
					`;
				} else {
					this.priceUnit.innerHTML = '';
				}
			}
		
		}

		updateStock(){

			if (!this.currentVariant) {
				if ( this.productStock ) {
					this.productStock.innerHTML = '';
				}
			} else {
				if ( this.productStock && this.productStockData ) {

					let currentVariant = false;
					for ( const variant of this.productStockData ) {
						if ( variant.id == this.currentVariant.id ) {
							currentVariant = variant;
							break;
						}
					}
					this.productStock.innerHTML = '';

					if ( currentVariant ) {

						if ( currentVariant.quantity <= 0 ) {
							if ( currentVariant.inventory == 'continue' ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_preorder;
								this.productStock.setAttribute('data-stock', 'pre-order');
							} else if ( currentVariant.inventory == 'deny' ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
								this.productStock.setAttribute('data-stock', 'out-of-stock');
							}
						} else if ( currentVariant.quantity == '1' ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_one_product;
							this.productStock.setAttribute('data-stock', 'one-item-stock');
						} else if ( currentVariant.quantity <= parseInt(this.productStock.dataset.lowStock) ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace('{{ count }}', currentVariant.quantity);
							this.productStock.setAttribute('data-stock', 'little-stock');
						} else if ( currentVariant.unavailable ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
							this.productStock.setAttribute('data-stock', 'out-of-stock');
						} else if ( currentVariant.quantity > parseInt(this.productStock.dataset.lowStock) && this.productStock.dataset.type == "always" ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_many_products.replace('{{ count }}', currentVariant.quantity);
							this.productStock.setAttribute('data-stock', 'in-stock');
						} else if ( ! currentVariant.quantity && this.productStock.dataset.type == "always" )  {
							this.productStock.innerHTML = KROWN.settings.locales.products_enough_products;
							this.productStock.setAttribute('data-stock', 'in-stock');
						}

						if ( this.productStockProgress ) {
							let progressQty = 0;
							if ( currentVariant.quantity <= 0 && currentVariant.inventory == 'continue' || typeof currentVariant.quantity === 'undefined' ) {
								progressQty = parseInt(this.productStock.dataset.highStock);
							} else if ( currentVariant.quantity > 0 ) {
								progressQty = currentVariant.quantity;
							}
							if ( progressQty >= parseInt(this.productStock.dataset.highStock)  ) {
								this.productStockProgress.style.width = `100%`;
							} else {
								this.productStockProgress.style.width = `${100 * progressQty / parseInt(this.productStock.dataset.highStock)}%`;
							}
						}

					}
				}
			}
		}

		updateDetails(){

			document.querySelectorAll(`#product-${this.dataset.id} [data-js-product-sku]`).forEach(elm=>{
				if ( this.currentVariant && this.currentVariant.sku ) {
					elm.innerHTML = KROWN.settings.locales.product_sku + this.currentVariant.sku;
				} else {
					elm.innerHTML = '';
				}
			});

			document.querySelectorAll(`#product-${this.dataset.id} [data-js-product-barcode]`).forEach(elm=>{
				if ( this.currentVariant && this.currentVariant.barcode ) {
					elm.innerHTML = KROWN.settings.locales.product_barcode + this.currentVariant.barcode;
				} else {
					elm.innerHTML = '';
				}
			});
			
		}

		updatePickupAvailability() {
			const pickUpAvailability = document.querySelector('pickup-availability');
			if (!pickUpAvailability) return;

			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id);
			} else {
				pickUpAvailability.removeAttribute('available');
				pickUpAvailability.innerHTML = '';
			}
		}

		updateUnavailableVariants(){

			if ( this.dataset.hideVariants != 'false' ) {

				if ( this.dataset.variants == '1' ) {

					/* Wert per JS vergleichen statt per CSS-Selektor: Variantennamen
					   dürfen Anführungszeichen enthalten (z.B. 16" MacBook Pro),
					   die einen Attribut-Selektor zerstören würden. */
					const variantValues = [...this.querySelectorAll('[data-js-product-variant-container] .product-variant-value')];

					this.variantData.forEach((variant) => {
						if ( ! variant.available ) {
							const input = variantValues.find(elm => elm.value === variant.option1);
							if ( ! input ) return;
							if ( this.dataset.hideVariants == 'disable' ) {
								input.setAttribute('disabled', 'disabled');
							} else {
								input.classList.add('disabled');
							}
							if ( input.parentElement ) {
								input.parentElement.classList.add('product-variant__item--disabled');
							}
						}
					});

				} else {

					const firstCheckedInput = this.querySelector(':checked');
					if ( firstCheckedInput && ! ( this.variantRequired && firstCheckedInput.value == '' ) ) {

						const selectedOptionOneVariants = this.variantData.filter(
							(variant) => firstCheckedInput.value === variant.option1
						);
	
						const inputWrappers = [...this.querySelectorAll('[data-js-product-variant]')];
						inputWrappers.forEach((option, index) => {
							if (index === 0) return;
							const optionInputs = [...option.querySelectorAll('input[type="radio"], option')].filter(input => input.value != '');
							const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
							const availableOptionInputsValue = selectedOptionOneVariants
								.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
								.map((variantOption) => variantOption[`option${index + 1}`]);
							this.setInputAvailability(optionInputs, availableOptionInputsValue);
						});
	
					}

				}

				// Check if all the variants in a group are disabled, show an "out of stock" message

				this.querySelectorAll('[data-js-product-variant]').forEach(variant=>{
					let allDisabled = true;
					variant.classList.remove('product-variant--all-disabled');
					variant.querySelector('.product-variant__out-of-stock')?.classList.add('hide');
					variant.querySelector('.product-variant__out-of-stock')?.setAttribute('aria-hidden', 'true');
					variant.querySelectorAll('.product-variant-value').forEach(variantInput=>{
						if ( ! ( variantInput.hasAttribute('disabled') || variantInput.classList.contains('disabled') ) ) {
							allDisabled = false;
						}
					});
					if ( allDisabled ) {
						variant.classList.add('product-variant--all-disabled');
						variant.querySelector('.product-variant__out-of-stock')?.classList.remove('hide');
						variant.querySelector('.product-variant__out-of-stock')?.removeAttribute('aria-hidden');
					}	
				});

			}

		}

		getSoldOutButtonText(){
			return this.dataset.soldOutButtonText || KROWN.settings.locales.products_sold_out_variant;
		}

		/* ---
			Hält pro Varianten-Wert fest, ob er lieferbar oder ausverkauft ist.
			Der Zustand steuert das Ausgrauen im Dropdown und die Lieferstatus-Zeile.
		--- */

		getSelectedOptionValues(groups){
			return groups.map(group=>{
				const checked = group.querySelector('input[type="radio"]:checked');
				if ( checked ) return checked.value;
				const select = group.querySelector('select');
				if ( select ) return select.value;
				return '';
			});
		}

		isOptionValueAvailable(variants, index, value, selectedValues){
			return variants.some(variant=>{
				if ( ! variant.available ) return false;
				if ( ( variant.options || [] )[index] !== value ) return false;
				for ( let i = 0; i < index; i++ ) {
					if ( selectedValues[i] && ( variant.options || [] )[i] !== selectedValues[i] ) return false;
				}
				return true;
			});
		}

		updateAvailabilityLabels(){

			if ( ! this.hasAttribute('data-availability-labels') ) return;

			const variants = this.getVariantData();
			const groups = [...this.querySelectorAll('[data-js-product-variant]')];
			const selectedValues = this.getSelectedOptionValues(groups);

			groups.forEach((group, index)=>{
				group.querySelectorAll('.product-variant-value').forEach(elm=>{
					if ( elm.classList.contains('product-variant-value--placeholder') || elm.value == '' ) return;
					const isSoldOut = ! this.isOptionValueAvailable(variants, index, elm.value, selectedValues);
					elm.setAttribute('data-availability', isSoldOut ? 'sold-out' : 'available');
				});
			});

		}

		setInputAvailability(listOfOptions, listOfAvailableOptions) {
			listOfOptions.forEach((input) => {
				if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
					if ( this.dataset.hideVariants == 'disable' ) {
						input.removeAttribute('disabled');
					} else {
						input.classList.remove('disabled');
					}
					input.parentElement.classList.remove('product-variant__item--disabled');
				} else {
					if ( this.dataset.hideVariants == 'disable' ) {
						input.setAttribute('disabled', 'disabled');
					} else {
						input.classList.add('disabled');
					}
					input.parentElement.classList.add('product-variant__item--disabled');
				}
			});
		}

		updateURL(){
			if (!this.currentVariant) return;
			window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
		}

			updateVariantInput() {
				const productForms = document.querySelectorAll(`#product-form-${this.dataset.id}, #product-form-installment`);
				productForms.forEach((productForm) => {
					const input = productForm.querySelector('input[name="id"]');
					if ( ! input ) return;
					if ( this.currentVariant ) {
						input.value = this.currentVariant.id;
					} else if ( this.variantRequired && this.noVariantSelectedYet && this.dataset.initialVariantId ) {
						input.value = this.dataset.initialVariantId;
					} else {
						input.value = '';
					}
					input.dispatchEvent(new Event('change', { bubbles: true }));
				});
			}

			getVariantRequiredText() {
				return this.dataset.variantRequiredText || KROWN.settings.locales.products_variant_required || KROWN.settings.locales.products_unavailable_variant;
			}

			getVariantValidationText() {
				return this.dataset.variantValidationText || this.getVariantRequiredText();
			}

			showVariantRequiredError() {
				const product = document.getElementById(`product-${this.dataset.id}`);
				const error = product ? product.querySelector('[data-variant-required-error]') : null;
				this.classList.add('variant-required--error');
				if ( error ) {
					error.textContent = this.getVariantValidationText();
					error.removeAttribute('hidden');
				}
				/* Ein <select> hier NICHT fokussieren: auf Smartphones öffnet ein Fokus
				   die System-Auswahlliste. Gewünscht ist nur der rote Rahmen. */
				const focusTarget = this.querySelector('input[type="radio"]');
				if ( focusTarget ) {
					focusTarget.focus({ preventScroll: true });
				}
				this.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}

			clearVariantRequiredError() {
				const product = document.getElementById(`product-${this.dataset.id}`);
				const error = product ? product.querySelector('[data-variant-required-error]') : null;
				this.classList.remove('variant-required--error');
				if ( this.productFormWrapper ) {
					this.productFormWrapper.classList.remove('variant-required-pending');
				}
				if ( error ) {
					error.setAttribute('hidden', 'hidden');
				}
			}

		getVariantData() {
			this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
			return this.variantData;
		}

		_formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount + KROWN.settings.iso_code;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

	}

  if ( typeof customElements.get('product-variants') == 'undefined' ) {
		customElements.define('product-variants', ProductVariants);
	}

}

/* ---
	Variant Dropdown

	Legt ein eigenes Dropdown über das native <select>. Nur so lassen sich
	Textfarben, rechtsbündiger Verfügbarkeits-Text und ausgegraute (nicht
	auswählbare) Einträge darstellen. Das <select> bleibt im DOM und behält die
	komplette Theme-Logik sowie die Tastatur-/Screenreader-Bedienung.
--- */

if ( typeof VariantDropdown !== 'function' ) {

	class VariantDropdown extends HTMLElement {

		constructor() {
			super();
			this.init();
		}

		init(){

			this.select = this.querySelector('select');
			this.cover = this.querySelector('[data-js-variant-dropdown-cover]');
			this.list = this.querySelector('[data-js-variant-dropdown-list]');
			if ( ! this.select || ! this.cover || ! this.list ) return;

			this.productVariants = this.closest('product-variants');
			this.variantGroup = this.closest('[data-js-product-variant]');
			this.behaviour = this.dataset.soldOutBehaviour || 'block';
			this.items = new Map();

			this.cover.addEventListener('click', this.onCoverClick.bind(this));
			this.list.addEventListener('click', this.onListClick.bind(this));
			this.select.addEventListener('change', ()=>{
				this.close();
				this.refresh();
			});

			this._onDocumentClick = (e)=>{
				if ( ! this.contains(e.target) ) this.close();
			};
			this._onDocumentKeydown = (e)=>{
				if ( e.key != 'Escape' ) return;
				if ( this.help && ! this.help.hidden ) {
					this.toggleHelp(false);
					return;
				}
				this.close();
			};
			document.addEventListener('click', this._onDocumentClick);
			document.addEventListener('keydown', this._onDocumentKeydown);

			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', ()=>this.refresh());
			}

			this.renderItems();
			this.initModelSearch();
			this.refresh();
			this.classList.add('variant-dropdown--ready');

		}

		/* Suche nach Modellnummer (A-Nummer). Die Zuordnung kommt aus den
		   Block-Einstellungen, eine Zeile pro Modell:
		   "15” MacBook Air: A2941, A3114, A3241, A3448"
		   Der Teil vor dem Doppelpunkt muss im Variantennamen vorkommen. */
		initModelSearch(){

			this.search = this.querySelector('[data-js-model-search]');
			if ( ! this.search ) return;

			this.searchInput = this.search.querySelector('[data-js-model-search-input]');
			this.infoButton = this.search.querySelector('[data-js-model-search-info]');
			this.help = this.querySelector('[data-js-model-search-help]');
			this.noMatchText = this.search.dataset.noMatch || '';
			this.codes = new Map();

			const entries = String(this.search.dataset.map || '').split(/\r?\n/).map(line=>{
				const index = line.indexOf(':');
				if ( index < 1 ) return null;
				const codes = ( line.slice(index + 1).match(/A?\s*\d{4}/gi) || [] ).map(code=>'A' + code.replace(/\D/g, ''));
				return codes.length ? { key: this.normalizeName(line.slice(0, index)), codes } : null;
			}).filter(Boolean);

			/* Pro Modell zählt nur der genaueste (längste) passende Schlüssel.
			   So bekommt "iPhone 17 Pro Max" nicht zusätzlich die Nummern von
			   "iPhone 17 Pro" oder "iPhone 17". */
			this.getOptions().forEach(option=>{
				const name = this.normalizeName(option.value);
				const matching = entries.filter(entry=>entry.key && name.includes(entry.key));
				const longest = Math.max(0, ...matching.map(entry=>entry.key.length));
				const codes = [];
				matching.filter(entry=>entry.key.length == longest).forEach(entry=>codes.push(...entry.codes));
				this.codes.set(option.value, [...new Set(codes)]);
			});

			const mobileQuery = window.matchMedia('(max-width: 767px)');
			if ( ! this.searchInput ) {
				/* Nur Hinweis ohne Eingabefeld (z. B. iPhone) */
				this.infoButton.addEventListener('click', ()=>this.toggleHelp());
				this.search.querySelector('[data-js-model-search-close]').addEventListener('click', ()=>this.close());
				if ( this.help ) this.help.querySelector('[data-js-model-search-help-close]').addEventListener('click', ()=>this.toggleHelp(false));
				return;
			}
			const setPlaceholder = ()=>{
				const text = mobileQuery.matches ? this.searchInput.dataset.placeholderMobile : this.searchInput.dataset.placeholderDesktop;
				if ( text ) this.searchInput.placeholder = text;
			};
			setPlaceholder();
			if ( mobileQuery.addEventListener ) mobileQuery.addEventListener('change', setPlaceholder);

			this.searchInput.addEventListener('input', ()=>{
				/* Sobald getippt wird, geht das Info-Fenster zu und die Treffer sind sichtbar. */
				this.toggleHelp(false);
				this.applySearch();
			});
			this.searchInput.addEventListener('keydown', e=>{
				if ( e.key != 'Enter' ) return;
				e.preventDefault();
				const matches = [...this.items.values()].filter(item=>item.classList.contains('variant-dropdown__item--match'));
				if ( matches.length == 1 ) matches[0].click();
			});
			this.infoButton.addEventListener('click', ()=>this.toggleHelp());
			this.search.querySelector('[data-js-model-search-close]').addEventListener('click', ()=>this.close());
			this.altToggle = this.help ? this.help.querySelector('[data-js-model-search-alt-toggle]') : null;
			this.alt = this.help ? this.help.querySelector('[data-js-model-search-alt]') : null;
			if ( this.altToggle && this.alt ) {
				this.altToggle.addEventListener('click', ()=>this.toggleAlt());
			}
			if ( this.help ) {
				this.help.querySelector('[data-js-model-search-help-close]').addEventListener('click', ()=>{
					this.toggleHelp(false);
					this.searchInput.focus();
				});
			}

		}

		normalizeName(value){
			return String(value).toLowerCase().replace(/[”“″„"'’]/g, '"').replace(/\s+/g, ' ').trim();
		}

		normalizeQuery(value){
			let query = String(value).toUpperCase().replace(/MODEL(L)?(NUMMER)?/g, '').replace(/[^A-Z0-9]/g, '');
			if ( /^\d/.test(query) ) query = 'A' + query;
			return query;
		}

		applySearch(){

			if ( ! this.search || ! this.searchInput ) return;

			const query = this.normalizeQuery(this.searchInput.value);
			const active = query.length > 1;
			let matchCount = 0;

			this.items.forEach((item, value)=>{
				const codes = this.codes.get(value) || [];
				const hits = active ? codes.filter(code=>code.startsWith(query)) : [];
				const isMatch = hits.length > 0;
				if ( isMatch ) matchCount++;
				item.classList.toggle('variant-dropdown__item--match', active && isMatch);
				item.classList.toggle('variant-dropdown__item--dimmed', active && ! isMatch);
				let tag = item.querySelector('.variant-dropdown__item-code');
				if ( active && isMatch ) {
					if ( ! tag ) {
						tag = document.createElement('span');
						tag.className = 'variant-dropdown__item-code';
						item.append(tag);
					}
					/* Nummern untereinander; bei vielen Treffern nur die ersten drei
					   plus Hinweis, damit der Modellname lesbar bleibt. */
					const shown = hits.length > 4 ? hits.slice(0, 3) : hits;
					tag.replaceChildren(...shown.map(code=>{
						const line = document.createElement('span');
						line.textContent = code;
						return line;
					}));
					if ( hits.length > shown.length ) {
						const more = document.createElement('span');
						more.className = 'variant-dropdown__item-code-more';
						more.textContent = '+' + ( hits.length - shown.length ) + ' weitere';
						tag.append(more);
					}
				} else if ( tag ) {
					tag.remove();
				}
			});

			let message = this.list.querySelector('.variant-dropdown__message');
			if ( active && matchCount == 0 && this.noMatchText ) {
				if ( ! message ) {
					message = document.createElement('li');
					message.className = 'variant-dropdown__message';
					this.list.prepend(message);
				}
				message.textContent = this.noMatchText;
			} else if ( message ) {
				message.remove();
			}

			const firstMatch = active ? [...this.items.values()].find(item=>item.classList.contains('variant-dropdown__item--match')) : null;
			if ( firstMatch ) firstMatch.scrollIntoView({ block: 'nearest' });

		}

		toggleHelp(force){
			if ( ! this.help ) return;
			const show = typeof force == 'boolean' ? force : this.help.hidden;
			this.help.hidden = ! show;
			this.infoButton.setAttribute('aria-expanded', show ? 'true' : 'false');
			if ( ! show ) this.toggleAlt(false);
		}

		/* Klappt im Info-Fenster den alternativen Weg auf (ohne neue Seite). */
		toggleAlt(force){
			if ( ! this.altToggle || ! this.alt ) return;
			const show = typeof force == 'boolean' ? force : this.alt.hidden;
			this.alt.hidden = ! show;
			this.altToggle.setAttribute('aria-expanded', show ? 'true' : 'false');
			if ( show ) this.altToggle.scrollIntoView({ block: 'start', behavior: 'smooth' });
		}

		resetSearch(){
			if ( ! this.search ) return;
			if ( ! this.searchInput ) {
				this.toggleHelp(false);
				return;
			}
			this.searchInput.value = '';
			this.toggleHelp(false);
			this.applySearch();
		}

		disconnectedCallback(){
			if ( this._onDocumentClick ) document.removeEventListener('click', this._onDocumentClick);
			if ( this._onDocumentKeydown ) document.removeEventListener('keydown', this._onDocumentKeydown);
		}

		getOptions(){
			return [...this.select.options].filter(option=>option.value !== '');
		}

		/* Bricht den Namen immer an derselben Stelle um: hinter der Klammer mit den
		   Modellnamen, direkt vor der Jahresklammer. Ohne zweite Klammer kein Umbruch.
		   Beispiel: "13\" MacBook Air (M2, M3, M4, M5)" / "(2022-2026) — 49,00 €" */
		splitLabel(label){
			const match = String(label).match(/^(.*?\))\s+(\(.*)$/);
			return match ? match[1] + '\n' + match[2] : label;
		}

		renderItems(){

			this.list.innerHTML = '';
			this.items.clear();

			this.getOptions().forEach(option=>{
				const item = document.createElement('li');
				item.className = 'variant-dropdown__item';
				item.dataset.value = option.value;
				const name = document.createElement('span');
				name.className = 'variant-dropdown__item-name';
				item.append(name);
				this.list.append(item);
				this.items.set(option.value, item);
			});

		}

		refresh(){

			const hideUnavailable = this.productVariants && this.productVariants.dataset.hideVariants == 'hide';

			this.getOptions().forEach(option=>{

				const item = this.items.get(option.value);
				if ( ! item ) return;

				const soldOut = option.dataset.availability == 'sold-out';
				const unavailable = option.disabled || option.classList.contains('disabled');

				item.querySelector('.variant-dropdown__item-name').textContent = this.splitLabel(option.dataset.baseLabel || option.value);
				item.setAttribute('data-availability', option.dataset.availability || '');
				item.setAttribute('data-selected', option.selected ? 'true' : 'false');

				// "Nur noch X verfügbar" bei wenig Bestand
				let stock = item.querySelector('.variant-dropdown__item-stock');
				const lowStock = ! soldOut && option.dataset.lowStock ? option.dataset.lowStock : '';
				if ( lowStock ) {
					if ( ! stock ) {
						stock = document.createElement('span');
						stock.className = 'variant-dropdown__item-stock';
						item.append(stock);
					}
					stock.textContent = lowStock;
				} else if ( stock ) {
					stock.remove();
				}
				item.classList.toggle('variant-dropdown__item--blocked', soldOut && this.behaviour != 'select');

				if ( hideUnavailable && unavailable ) {
					item.setAttribute('hidden', 'hidden');
				} else {
					item.removeAttribute('hidden');
				}

			});

			const selected = this.select.options[this.select.selectedIndex];
			const coverName = this.cover.querySelector('.variant-dropdown__cover-name');
			if ( selected ) {
				const isPlaceholder = selected.value === '';
				coverName.textContent = isPlaceholder ? selected.textContent.trim() : this.splitLabel(selected.dataset.baseLabel || selected.value);
				this.cover.setAttribute('data-availability', isPlaceholder ? '' : ( selected.dataset.availability || '' ));
			}

		}

		onCoverClick(){
			if ( this.classList.contains('variant-dropdown--open') ) {
				this.close();
			} else {
				this.open();
			}
		}

		open(){
			this.classList.add('variant-dropdown--open');
			this.markProductState();
			const selected = this.list.querySelector('[data-selected="true"]');
			if ( selected ) selected.scrollIntoView({ block: 'nearest' });
			/* Auf Geräten mit Maus immer direkt ins Suchfeld. Auf dem Handy nur, wenn
			   im Theme-Editor eingestellt (dann geht sofort die Tastatur auf). */
			if ( this.searchInput && ( window.matchMedia('(hover: hover)').matches || this.search.hasAttribute('data-focus-touch') ) ) this.searchInput.focus({ preventScroll: true });
		}

		close(){
			this.classList.remove('variant-dropdown--open');
			this.markProductState();
			this.resetSearch();
		}

		/* Merkt am Produkt-Container, ob irgendein Dropdown offen ist. Daran hängt
		   z.B. die Hervorhebung des Größentabellen-Hinweises. Wird jedes Mal neu aus
		   dem DOM bestimmt, damit mehrere Dropdowns sich nicht gegenseitig aufheben. */
		markProductState(){
			const page = this.closest('product-page');
			if ( ! page ) return;
			page.classList.toggle('variant-dropdown-is-open', !! page.querySelector('variant-dropdown.variant-dropdown--open'));
		}

		onListClick(e){

			const item = e.target.closest('.variant-dropdown__item');
			if ( ! item ) return;

			const option = [...this.select.options].find(elm=>elm.value === item.dataset.value);
			if ( ! option ) return;

			if ( item.dataset.availability == 'sold-out' && this.behaviour != 'select' ) {
				if ( this.behaviour == 'notify' ) {
					this.requestNotify(option);
					this.close();
				}
				return;
			}

			if ( option.disabled ) return;

			this.select.value = option.value;
			this.select.dispatchEvent(new Event('change', { bubbles: true }));
			this.close();

		}

		requestNotify(option){
			this.dispatchEvent(new CustomEvent('variant:notify-request', {
				bubbles: true,
				detail: {
					sectionId: this.productVariants ? this.productVariants.dataset.id : '',
					label: option.dataset.baseLabel || option.value,
					variant: this.resolveVariant(option.value)
				}
			}));
		}

		resolveVariant(value){

			if ( ! this.productVariants || typeof this.productVariants.getVariantData !== 'function' ) return null;

			const groups = [...this.productVariants.querySelectorAll('[data-js-product-variant]')];
			const index = groups.indexOf(this.variantGroup);
			if ( index < 0 ) return null;

			const selectedValues = typeof this.productVariants.getSelectedOptionValues === 'function' ? this.productVariants.getSelectedOptionValues(groups) : [];
			selectedValues[index] = value;

			return this.productVariants.getVariantData().find(variant=>{
				return selectedValues.every((selectedValue, i)=>{
					return ! selectedValue || ( variant.options || [] )[i] === selectedValue;
				});
			}) || null;

		}

	}

	if ( typeof customElements.get('variant-dropdown') == 'undefined' ) {
		customElements.define('variant-dropdown', VariantDropdown);
	}

}

/* ---
	Product Form
--- */

if ( typeof ProductForm !== 'function' ) {

	class ProductForm extends HTMLElement {
		constructor() {
			super();   
			this.init();
		}

			init(){
				this.cartType = this.hasAttribute('data-ajax-cart') ? 'ajax' : 'page';
				if ( ! document.body.classList.contains('template-cart') || this.hasAttribute('data-force-form' ) ) {
					this.form = this.querySelector('form');
					this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
					this.form.addEventListener('click', this.onFormClick.bind(this), true);
					this.form.addEventListener('pointerdown', this.onFormClick.bind(this), true);
					this.form.addEventListener('touchstart', this.onFormClick.bind(this), true);
					this.ADD_TO_CART = new Event('add-to-cart');
				}
			if ( document.body.classList.contains('touchevents') ) {
				const submitButton = this.querySelector('[type="submit"]');
				if ( submitButton ) {
					submitButton.addEventListener('touchend', e=>{
						//submitButton.click();
					});
				}
				}
				}

				onFormClick(e) {
					const clickedPaymentButton = e.target.closest('.shopify-payment-button, .shopify-payment-button button, .shopify-payment-button__button, [data-testid="ShopifyPay-button"]');
					if ( clickedPaymentButton && this.hasMissingRequiredVariant() ) {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
						this.handleMissingRequiredVariant();
					}
				}

			onSubmitHandler(e) {	

				e.preventDefault();
				
				const submitButton = this.querySelector('[type="submit"]');

				if ( this.hasMissingRequiredVariant() ) {
					this.handleMissingRequiredVariant();
					return;
				}

				const variantInput = this.form.querySelector('input[name="id"]');
				if ( variantInput && ! variantInput.value ) {
					this.handleMissingRequiredVariant();
					return;
				}

			submitButton.classList.add('working');

			const body = this._serializeForm(this.form);
			let alert = '';

			fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
				body,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'X-Requested-With': 'XMLHttpRequest'
				},
				method: 'POST'
			})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.className = 'alert alert--error';
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						if ( this.cartType == 'page' ) {
							if ( document.getElementById('product-page-form-error-cart-alert') ) {
								document.getElementById('product-page-form-error-cart-alert').remove();
							}
							alert.style.marginTop = '1em';
							alert.style.marginBottom = '0';
							alert.id = 'product-page-form-error-cart-alert';
							this.form.parentElement.append(alert);
							return false;
						}
						return fetch('?section_id=helper-cart');
					} else {
						if ( this.cartType == 'page' ) {
							document.location.href = KROWN.settings.routes.cart_url;
							return false;
						} else {
							return fetch('?section_id=helper-cart');
						}
					}
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					if ( document.getElementById('AjaxCartForm') ) {

						const cartItems = document.getElementById('AjaxCartForm');
						cartItems.innerHTML = cartFormInnerHTML;
						cartItems.ajaxifyCartItems();

						if ( alert != '' ) {
							document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
						}

						document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});

					}
					
					this.dispatchEvent(this.ADD_TO_CART);

					// a11y
					if ( document.getElementById('screen-reader-info') ) {
						document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
						setTimeout(()=>{
							document.getElementById('screen-reader-info').innerText = '';
						}, 1000);
					}

				})
				.catch(e => {
					console.log(e);
				})
				.finally(() => {
					submitButton.classList.remove('working');
				});
			}

				hasMissingRequiredVariant() {
					const productVariants = this.getProductVariants();
					return !!( productVariants && productVariants.variantRequired && productVariants.noVariantSelectedYet );
				}

			handleMissingRequiredVariant() {
				const productVariants = this.getProductVariants();
				if ( productVariants && typeof productVariants.showVariantRequiredError === 'function' ) {
					productVariants.showVariantRequiredError();
				}
			}

			getProductVariants() {
				const sectionId = this.dataset.productSectionId || this.id?.replace('add-to-cart-', '');
				return sectionId ? document.querySelector(`#product-${sectionId} product-variants`) : null;
			}

			_serializeForm(form) {
			let arr = [];
			Array.prototype.slice.call(form.elements).forEach(function(field) {
				if (
					!field.name ||
					field.disabled ||
					['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
				)
					return;
				if (field.type === 'select-multiple') {
					Array.prototype.slice.call(field.options).forEach(function(option) {
						if (!option.selected) return;
						arr.push(
							encodeURIComponent(field.name) +
								'=' +
								encodeURIComponent(option.value)
						);
					});
					return;
				}
				if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
					return;
				arr.push(
					encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
				);
			});
			return arr.join('&');
		}

	}

  if ( typeof customElements.get('product-form') == 'undefined' ) {
		customElements.define('product-form', ProductForm);
	}

}

/* ---
	Product Recommendations
--- */

if ( typeof ProductRecommendations !== 'function' ) {
	class ProductRecommendations extends HTMLElement {

		constructor() {

			super();  
      
      const SUCCESS = new Event('product-recommendations-loaded');
      const FAIL = new Event('product-recommendations-error');

      const handleIntersection = (entries, observer) => {

        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');

								if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll('form').forEach(elm=>{
                if (elm.querySelector('template')) {
                  elm.append(elm.querySelector('template').content.cloneNode(true));
                }
              });
              this.dispatchEvent(SUCCESS);
            } else {
							this.dispatchEvent(FAIL);
						}
          })
          .catch(e => {
						this.dispatchEvent(FAIL);
          });
      }

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this);

		}

	}
	
  if ( typeof customElements.get('product-recommendations') == 'undefined' ) {
		customElements.define('product-recommendations', ProductRecommendations);
	}

}

/* ---
	Gift card recipent
--- */

if ( typeof GiftCardRecipient !== 'function' ) {

	class GiftCardRecipient extends HTMLElement {

		constructor() {

			super();

			const properties = Array.from(this.querySelectorAll('[name*="properties"]'));
			const checkboxPropertyName = 'properties[__shopify_send_gift_card_to_recipient]';

			this.recipientCheckbox = properties.find(input => input.name === checkboxPropertyName);
			this.recipientOtherProperties = properties.filter(input => input.name !== checkboxPropertyName);
			this.recipientFieldsContainer = this.querySelector('.gift-card-recipient__fields');

			if ( this.recipientCheckbox ) {
				this.recipientCheckbox.addEventListener('change', this.synchronizeProperties.bind(this));
			}
			this.synchronizeProperties();

		}

		synchronizeProperties() {
			this.recipientOtherProperties.forEach(property => property.disabled = !this.recipientCheckbox.checked);
			this.recipientFieldsContainer.classList.toggle('hide', !this.recipientCheckbox.checked);
		}

	}

  if ( typeof customElements.get('gift-card-recipient') == 'undefined' ) {
		customElements.define('gift-card-recipient', GiftCardRecipient);
	}

}

/* ---
	Sticky Add to Cart
--- */

if ( typeof StickyAddToCart !== 'function' ) {
	class StickyAddToCart extends HTMLElement {
		
		constructor() {

			super();  

			const productPage = document.getElementById(this.dataset.id);
			this.hasAttribute('data-append-to') ? document.querySelector(this.dataset.appendTo).appendChild(this) : document.body.appendChild(this);
			
			const productButton = productPage.querySelector('[data-js-product-add-to-cart]');
			const stickyBar = this;
			
			function toggleStickyBarOnScroll() {
				const rect = productButton.getBoundingClientRect();
				const isInViewport = (
						rect.top >= 0 &&
						rect.left >= 0 &&
						( rect.bottom - 80 ) <= (window.innerHeight || document.documentElement.clientHeight) &&
						rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				);
				const isMobile = window.innerWidth < 728;

				if ( ( ! isMobile && rect.top < 0 ) || ( isMobile && ! isInViewport ) ) {
					stickyBar.classList.add('visible');
				} else {
					stickyBar.classList.remove('visible');
				}
			}
			window.addEventListener('scroll', toggleStickyBarOnScroll);
			toggleStickyBarOnScroll();

			if ( this.hasAttribute('data-single') ) {

				const stickyButton = this.querySelector('button[data-js-atc]');

				stickyButton.addEventListener('click', ()=>{
					productButton.click();
					stickyButton.classList.add('working');
				});
				
				new MutationObserver(()=>{
					if ( productButton.classList.contains('working') ) {
						stickyButton.classList.add('working');
					} else {
						stickyButton.classList.remove('working');
					}
				}).observe(productButton, {
					attributes: true, childList: false, subtree: false
				})

			} else {

				this.querySelector('button[data-js-choose]').addEventListener('click', ()=>{
					productButton.scrollIntoView({behavior: "smooth", block: "center"});
				});

			}

		}

	}

  if ( typeof customElements.get('sticky-add-to-cart') == 'undefined' ) {
		customElements.define('sticky-add-to-cart', StickyAddToCart);
	}

}
